import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CheckCircle, Calendar, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import Navbar from '../components/Navbar';

export default function SeminarSuccessPage() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const isEl = i18n.language === 'el';

  useEffect(() => {
    // Optional: Verify session with backend
    // For now, just show success message
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-misel-dark">
      <Navbar />
      
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-lg mx-auto text-center">
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-green-500/20 flex items-center justify-center">
            <CheckCircle className="text-green-500" size={40} />
          </div>
          
          <h1 className="text-3xl font-bold text-white mb-4">
            {isEl ? 'Επιτυχής Κράτηση!' : 'Booking Successful!'}
          </h1>
          
          <p className="text-gray-400 mb-8">
            {isEl 
              ? 'Το εισιτήριό σας έχει επιβεβαιωθεί. Θα λάβετε email με τις λεπτομέρειες και το link για το Zoom.' 
              : 'Your ticket has been confirmed. You will receive an email with details and your Zoom link.'}
          </p>

          <div className="bg-misel-card border border-white/10 rounded-sm p-6 mb-8">
            <div className="flex items-center justify-center gap-2 text-primary mb-3">
              <Calendar size={20} />
              <span className="font-medium">
                {isEl ? 'Τι γίνεται τώρα;' : "What's next?"}
              </span>
            </div>
            <ul className="text-sm text-gray-400 space-y-2 text-left">
              <li>• {isEl ? 'Θα λάβετε email επιβεβαίωσης' : 'You will receive a confirmation email'}</li>
              <li>• {isEl ? 'Υπενθύμιση 24 ώρες, 1 ώρα και 10 λεπτά πριν' : 'Reminders 24h, 1h and 10min before'}</li>
              <li>• {isEl ? 'Το Zoom link θα είναι διαθέσιμο στα "Τα Σεμινάριά μου"' : 'Zoom link will be available in "My Seminars"'}</li>
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate('/my-seminars')}
              className="bg-primary hover:bg-primary/90"
            >
              {isEl ? 'Τα Σεμινάριά μου' : 'My Seminars'}
              <ArrowRight size={16} className="ml-2" />
            </Button>
            
            <Button
              variant="outline"
              onClick={() => navigate('/seminars')}
              className="border-white/20 hover:bg-white/5"
            >
              {isEl ? 'Δες περισσότερα σεμινάρια' : 'Browse more seminars'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
